import { FormControl, FormLabel } from "@chakra-ui/form-control";
import { FormErrorMessage, FormHelperText, InputGroup } from "@chakra-ui/react";
import { Select } from "@chakra-ui/select";
import { at } from "lodash";
import React from "react";
import useFieldFast from "../../hooks/useFieldFast";
import useInProgressDisable from "../../hooks/useInProgressDisable";

export type SelectFieldProps = {
  label: string;
  placeholder: string;
  data: { value: any; label: string; disabled?: boolean }[];
  name: string;
  errorText?: string;
  helperText?: string | React.ReactElement;
  disabled?: any;
};

function SelectField(props: SelectFieldProps) {
  const { label, data, name, helperText, placeholder, disabled } = props;
  const [field, meta] = useFieldFast(props);
  const { value: selectedValue } = field;

  function renderHelperText() {
    const [touched, error] = at(meta, "touched", "error");

    if (touched && error) {
      return error;
    }
  }

  return (
    <FormControl
      id={name}
      isInvalid={meta.touched && !!meta.error}
      isDisabled={useInProgressDisable(name) || disabled}
    >
      <FormLabel>{label}</FormLabel>
      <InputGroup>
        <Select
          {...field}
          placeholder={placeholder}
          value={selectedValue ?? ""}
          data-testid={`${label}-select`}
        >
          {data.map((option) => (
            <option
              key={option.value}
              value={option.value}
              disabled={option.disabled}
              data-testid={`${label}-select-option`}
            >
              {option.label}
            </option>
          ))}
        </Select>
      </InputGroup>
      {meta.touched && meta.error ? (
        <FormErrorMessage>{renderHelperText()}</FormErrorMessage>
      ) : (
        helperText && <FormHelperText>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
}

export default SelectField;
